/**
 * @generated SignedSource<<c87d3b8f2534c06728b678f556779fad>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type WhatToSeeEditMain_data$data = {
  readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeEditMainFields_data">;
  readonly " $fragmentType": "WhatToSeeEditMain_data";
};
export type WhatToSeeEditMain_data$key = {
  readonly " $data"?: WhatToSeeEditMain_data$data;
  readonly " $fragmentSpreads": FragmentRefs<"WhatToSeeEditMain_data">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "WhatToSeeEditMain_data",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "WhatToSeeEditMainFields_data"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "bd70a626f895af20e6daf871516442de";

export default node;
